export default __webpack_public_path__ + "static/media/logo.65abdc13.png";